import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaEdit, FaImage } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { ThemeContext } from "../../../context/ThemeContext";
import { Table, Pagination } from "rsuite";
import { useGetAllPremisesQuery } from "../../../features/premises/premisesApi";
import { usePremisesStoreMutation } from "../../../features/premises/premisesApi";
import { useUpdatePremisesInfoMutation } from "../../../features/premises/premisesApi";
import getBase64 from "../../../helper/helper";
import "./styles/premises.css";
const { Column, HeaderCell, Cell } = Table;

function Premises() {
  const theme = React.useContext(ThemeContext);
  const [show, setShow] = React.useState(false);
  const [createFormSelector, setCreateFormSelector] = useState(true);
  const [reseponseMessage, setResponseMessage] = useState();
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [updateFormData, setUpdateFormData] = useState({});

  const { data: allPremisesData, isLoading, error } = useGetAllPremisesQuery();
  const [premisesStore, { data: premisesStoreResponse }] =
    usePremisesStoreMutation();

  const [updatePremisesInfo, { data: updatePremisesResponse }] =
    useUpdatePremisesInfoMutation();

  const [imageShow, setImageShow] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [file, setFile] = useState(null);
  let defaultData = [];
  let data = [];

  useEffect(() => {
    if (updatePremisesResponse) {
      setResponseMessage(updatePremisesResponse?.message);
    }
  }, [updatePremisesResponse]);

  if (!isLoading) {
    
    if (allPremisesData.success) {
      defaultData = [...allPremisesData?.data];
      defaultData = defaultData?.map((premesisInfo) => {
        const data = new Date(premesisInfo.updated_at);
        const formattedDate = data.toLocaleString();
        return {
          ...premesisInfo,
          updated_at: formattedDate,
        };
      });
    }

    data = defaultData?.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
  }

  // const handleChange = (e) => {
  //   alert(e.target.name);

  //   setFile(e.target.files[0]);
  //   if (file) {
  //     setImageUrl(URL.createObjectURL(file));
  //   } else {
  //     setImageUrl(null);
  //   }
  // };

  // if (updatePremisesResult || result) {
  //   console.log(updatePremisesResult || result);
  // }

  const handleClose = () => {
    setShow(false);
    setImageShow(false);
  };
  const handleModalOutsideClick = () => {
    setShow(false);
    setResponseMessage("");
  };
  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };
  const formSubmitHandler = (e) => {
    e.preventDefault();

    if (createFormSelector) {
      // alert("Create Form");
      // console.log(JSON.stringify(updateFormData));
      premisesStore(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
      // premisesStore({
      //   name: "Jamuna 570",
      //   country_id: "1",
      //   address: "Khustia",
      //   area_size: "1000 sqr",
      //   lat: "1",
      //   long: "5000",
      //   area_map: "",
      //   building_num: "5",
      // });
    } else {
      // alert("Update Form");
      // console.log(JSON.stringify(updateFormData));
      updatePremisesInfo(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
      // updatePremisesInfo({
      //   id: 63,
      //   name: "Padmaa",
      //   country_id: "2",
      //   address: "Khustia1",
      //   area_size: "1000 sqrs",
      //   lat: "1001",
      //   long:"1003",
      //   area_map: null,
      //   building_num: "5",
      // });
    }
  };
  const handleEdit = (id) => {
    // alert(id);
    let formData = defaultData.find((object) => object.id == id) || {};

    delete formData.area_map; // as updating empty value keeps previous image on db
    setUpdateFormData(formData);
    // console.log(formData);
  };
  const dataChangeHandler = (e) => {
    if (e.target.name === "area_map") {
      getBase64(e.target.files[0])
        .then((base64image) => {
          setUpdateFormData((previousValue) => ({
            ...previousValue,
            [e.target.name]: base64image,
          }));
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setUpdateFormData((previousValue) => ({
        ...previousValue,
        [e.target.name]: e.target.value,
      }));
    }
    // console.log(updateFormData);
  };

  const imageShowHandler = (area_map) => {
    console.log(area_map);
  };
  const imageModalOutsideClick = () => {
    setImageShow(false);
  };

  return (
    <div className={`row row-sm ${theme} `}>
      <div style={{ textAlign: "right", marginBottom: "1rem" }}>
        <button
          className="btn btn-primary btn-md "
          // style={{ width: "20vw" }}
          onClick={() => {
            setShow(true);
            setCreateFormSelector(true);
            setUpdateFormData({});
          }}
        >
          Add Premises
        </button>
        {/* </div> */}
      </div>
      <Modal
        show={imageShow}
        onHide={handleClose}
        className={`${theme} `}
        onExited={imageModalOutsideClick}
        centered
      >
        <div className={`${theme}`}>
          <Modal.Header
            className="theme-background theme-text"
            style={{ borderRadius: "0px" }}
          >
            <Modal.Title>Image</Modal.Title>

            <RxCross2 onClick={imageModalOutsideClick} />
          </Modal.Header>
          <Modal.Body className="theme-background theme-text">
            {" "}
            <img
              className="image_inside_modal"
              src={imageUrl}
              alt="modal_image"
            ></img>
          </Modal.Body>
        </div>
      </Modal>
      <Modal
        show={show}
        onHide={handleClose}
        classname={`${theme} `}
        centered
        onExited={handleModalOutsideClick}
      >
        <div className={`${theme}`}>
          <Modal.Header
            className="theme-background theme-text"
            style={{ borderRadius: "0px" }}
          >
            <Modal.Title>
              {createFormSelector ? "Add Premises" : "Update Premises"}
            </Modal.Title>
            <div style={{ color: "green" }}>{reseponseMessage}</div>
            <RxCross2 onClick={handleModalOutsideClick} />
          </Modal.Header>
          <Modal.Body className="theme-background theme-text">
            {" "}
            <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 zero-padding">
              <div>
                <div>
                  <form onSubmit={formSubmitHandler}>
                    <div className="form-group">
                      <label for="premisesName">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Premises Name"
                        // value={name}
                        name="name"
                        defaultValue={updateFormData?.name || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label for="countryName">Country</label>
                      <input
                        type="number"
                        className="form-control"
                        name="country_id"
                        placeholder="Country Code"
                        defaultValue={updateFormData?.country_id || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label for="address">Address</label>
                      <input
                        type="text"
                        name="address"
                        placeholder="Address"
                        defaultValue={updateFormData?.address || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label for="address">Area</label>
                      <input
                        type="text"
                        name="area_size"
                        placeholder="Area"
                        defaultValue={updateFormData?.area_size || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        className="form-control"
                        required
                      />
                    </div>
                    <div
                      className="input-group theme-background theme-text"
                      style={{ border: "0px" }}
                    >
                      <label
                        for="latitude"
                        className="form-control theme-background theme-text"
                        style={{ border: "0px", marginLeft: "-0.6rem" }}
                      >
                        Latitude
                      </label>
                      {/* <span class="input-group-addon">-</span> */}
                      <label
                        for="longitude"
                        className="form-control theme-background theme-text"
                        style={{ border: "0px", paddingLeft: "2rem" }}
                      >
                        Longitude
                      </label>
                    </div>
                    <div
                      className="input-group"
                      style={{ paddingBottom: "0.8rem" }}
                    >
                      <input
                        type="number"
                        step="any"
                        className="form-control"
                        placeholder="Latitude"
                        name="lat"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.lat || ""}
                        required
                      />
                      <span className="input-group-addon">-</span>
                      <input
                        type="number"
                        step="any"
                        className="form-control"
                        placeholder="Longitude"
                        name="long"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.long || ""}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label for="areaMap">Area Map</label>
                      <input
                        type="file"
                        name="area_map"
                        placeholder="Area Map"
                        // defaultValue={updateFormData?.area_map || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                          // handleChange(e);
                        }}
                        className="form-control"
                      />
                      {/* <img
                        src={imageUrl ? imageUrl : updateFormData?.area_map}
                      />{" "} */}
                    </div>
                    <div className="form-group">
                      <label for="noOfBuildings">No. Of Buildings</label>
                      <input
                        type="number"
                        name="building_num"
                        placeholder="No Of buildings"
                        defaultValue={updateFormData?.building_num || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        className="form-control"
                        required
                      />
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <Button type="submit">Submit</Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <div>
        <div className="table-responsive theme-background theme-text">
          <Table
            height={500}
            data={data || []}
            loading={defaultData.length > 0 ? false : true}
          >
            <Column
              width={50}
              align="center"
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Id.</HeaderCell>
              <Cell dataKey="id" />
            </Column>
            <Column
              width={150}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Name</HeaderCell>
              <Cell dataKey="name" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Country</HeaderCell>
              <Cell dataKey="country_id" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Address</HeaderCell>
              <Cell dataKey="address" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Area Size</HeaderCell>
              <Cell dataKey="area_size" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Latitude</HeaderCell>
              <Cell dataKey="lat" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Longitude</HeaderCell>
              <Cell dataKey="long" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Area Map</HeaderCell>
              <Cell dataKey="area_map">
                {(rowData) => (
                  <div
                    icon="edit"
                    onClick={() => {
                      setImageShow(true);
                      setImageUrl(rowData?.area_map);
                      // setImageUrl("https://via.placeholder.com/600/92c952");
                    }}
                  >
                    {/* <FaImage /> */}
                    <img
                      className="premises_map_image"
                      src={rowData?.area_map || ""}
                    ></img>
                  </div>
                )}
              </Cell>
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>
                No. Of Buildings
              </HeaderCell>
              <Cell dataKey="building_num" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Last Updated</HeaderCell>
              <Cell dataKey="updated_at" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Edit</HeaderCell>
              <Cell>
                {(rowData) => (
                  <div
                    icon="edit"
                    onClick={() => {
                      setShow(true);
                      setCreateFormSelector(false);
                      handleEdit(rowData.id);
                    }}
                  >
                    <FaEdit />
                  </div>
                )}
              </Cell>
            </Column>
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="lg"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={defaultData.length}
              limitOptions={[10, 30, 50]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Premises;
